//@flow
import { ACCESS_TOKEN, REFRESH_TOKEN } from "./constants"
import type { UserRegistration } from "./types"
import * as userHelpers from "./userHelpers"
import * as tokenHelpers from "./tokenHelpers"
import Authenticator from "./Authenticator"
import KioskAuthenticator from "./KioskAuthenticator"

export type { UserRegistration }

const {
  createUser,
  loginUser,
  logoutUser,
  isLoggedIn,
  sendMagicLink
} = userHelpers

const {
  refreshToken,
  refreshTokens,
  saveTokens,
  accessToken,
  isAdmin,
  nonAsyncAccessToken,
  nonAsyncRefreshToken
} = tokenHelpers

export {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  createUser,
  loginUser,
  logoutUser,
  isLoggedIn,
  sendMagicLink,
  refreshToken,
  refreshTokens,
  saveTokens,
  accessToken,
  isAdmin,
  Authenticator,
  KioskAuthenticator,
  nonAsyncAccessToken,
  nonAsyncRefreshToken
}



// WEBPACK FOOTER //
// ./src/Auth/index.js